import type { LoginFormData } from "./store/types";

export const validateLoginForm = (data: LoginFormData) => {
  const errors: Record<string, string> = {};
  const phone = (data.phone || "").trim();
  if (!phone) {
    errors.phone = "Phone is required";
  } else if (!/^\+\d{10,15}$/.test(phone)) {
    errors.phone = "Enter a valid mobile number";
  }
  if (!data.password) {
    errors.password = "Password is required";
  }
  return errors;
};
